import React from 'react';

import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';

type Props = {
  id: string;
};

const About: React.FC<Props> = (props) => {
  return (
    <div id={props.id} data-testid={props.id}>
      <Navbar id="navbar" />
      <h1>ABOUT</h1>
      <Footer id="footer" />
    </div>
  );
};

export default About;
